var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00496 13.9961C0.806508 13.9973 0.612204 13.9393 0.446824 13.8296C0.281445 13.7199 0.152482 13.5634 0.0763802 13.3801C0.00027788 13.1969 -0.0195168 12.9951 0.0195197 12.8005C0.0585563 12.6059 0.154656 12.4273 0.295565 12.2876L5.59108 7.00207L0.295565 1.71655C0.107421 1.5284 0.00172257 1.27322 0.00172257 1.00715C0.00172257 0.8754 0.027672 0.744943 0.0780896 0.623224C0.128507 0.501505 0.202406 0.390909 0.295565 0.297749C0.388725 0.204589 0.499321 0.130691 0.62104 0.0802738C0.742759 0.0298562 0.873217 0.00390625 1.00496 0.00390625C1.27104 0.00390625 1.52622 0.109605 1.71436 0.297749L7.70928 6.29267C7.89538 6.47987 7.99983 6.73311 7.99983 6.99707C7.99983 7.26103 7.89538 7.51427 7.70928 7.70148L1.71436 13.6964C1.62183 13.7908 1.51148 13.8659 1.3897 13.9174C1.26793 13.9688 1.13716 13.9956 1.00496 13.9961Z",
    fill: "#C70048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev1);
export default __webpack_public_path__ + "static/media/prev1.57ecd6e045673737dd80573d19242fe9.svg";
export { ForwardRef as ReactComponent };